module.exports = __webpack_public_path__ + "static/dk-tuning-d49fd227bc24843c5aa145ae53649cc1.png";